
import { trackImpression, TrackImpressionAction } from '../../redux/actions/impressions';
import { playTrackFromQueue, PlayTrackFromQueueAction } from '../../redux/actions/player';
import { EventCategory, EventDefinition, EventsMap, ProductEvent } from '../types';

function productImpressionFromTrack(track: GQL.ITrackSearchResult) {
  return {
    id: track.internal_id,
    name: track.title,
    price: track.price ? track.price : undefined,
    brand: track.artist!.name,
    category: 'License',
    list: window.location.pathname,
  };
}

const trackImpressionEvent: EventDefinition<TrackImpressionAction> = ({ payload }) => ({
  category: EventCategory.Impression,
  event: ProductEvent.Impression,
  action: 'show-track',
  label: `${payload.track.internal_id}`,
  ecommerce: {
    impressions: [productImpressionFromTrack(payload.track)],
  },
});

// Given that playing a track is the most important track "detail" a user can "view"
// that leads to its purchase, we use track play events to record "product details" views
const playTrackEvent: EventDefinition<PlayTrackFromQueueAction> = (_, __, { player }) => {
  const track = player.currentTrack!.trackInfo;
  return {
    category: EventCategory.Impression,
    event: ProductEvent.Details,
    action: 'play-track',
    label: `${track.internal_id}`,
    ecommerce: {
      actionField: { list: window.location.pathname },
      detail: {
        products: [productImpressionFromTrack(track)],
      },
    },
  };
};

export const impressionsEventsMap: EventsMap = {
  [trackImpression.type]: trackImpressionEvent,
  [playTrackFromQueue.type]: playTrackEvent,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/analytics/events/impressions.ts